import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Events = () => {
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const lang = i18n.language;
    
    setLoading(true); // Set loading to true before request
    axios.get(`${process.env.REACT_APP_API_URL}/api/events?lang=${lang}`)
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error('Error fetching events:', error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false after request
      });
  }, [i18n.language]);

  return (
    <div className="events-page">
      {loading ? (
        <p className="loading-message">{t('loading')}</p>
      ) : (
        <div className="cards-container">
          {events.map((event, index) => (
            <div className="card" key={index}>
              <h3>{event.name}</h3>
              <p>{t('date')} {event.date}</p>
              <p>{event.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Events;
